import { useAppSelector } from '../../redux';
import { useGetPolylineQuery } from '../../redux/mapsApi';
import { LngLat } from '../../types/Geo';
import { decodeSegmentLngLat } from '../../utils/legacyGeoJSONConversions';
import Polyline from '../Polyline';

const ActiveTrailPolyline = ({ trailId }: { trailId: number }) => {
  const { data } = useGetPolylineQuery({ trailId });

  if (!data) {
    return null;
  }

  return <Polyline coordinates={data} uniqueId={String(trailId)} />;
};

const ActiveTrailCachedPolyline = ({ trailId, polyline }: { trailId: number; polyline: string }) => {
  return <Polyline coordinates={decodeSegmentLngLat({ polyline: { pointsData: polyline } }) as LngLat[]} uniqueId={String(trailId)} />;
};

const ActiveTrailPolylines = () => {
  const { activeTrails } = useAppSelector(state => ({ activeTrails: state.map.activeTrails }));

  if (!activeTrails) {
    return null;
  }

  return (
    <>
      {activeTrails.map(trail => {
        if (!trail) {
          return null;
        }
        const { ID, polyline } = trail;
        return polyline ? <ActiveTrailCachedPolyline key={ID} polyline={polyline} trailId={ID} /> : <ActiveTrailPolyline key={ID} trailId={ID} />;
      })}
    </>
  );
};

export default ActiveTrailPolylines;
